export default "__VITE_ASSET__BddwIuaW__"